import React from 'react'
import { billingPath } from 'routes/url-constants'

import { PaymentBlockingReason } from 'utils/payment-limit'

type Props = {
  reason?: PaymentBlockingReason
}

export const BlockingWarning: React.FC<Props> = ({ reason = 'blocked' }) => {
  if (reason === 'limitExceeded') {
    return (
      <div className="text-danger p-1" style={{ margin: '0px -15px' }}>
        <h4 className="text-danger p-1">Внимание!</h4>
        <p className="text-danger p-1">Превышен лимит расходов за месяц. Для создания новых заявок обратитесь к администратору.</p>
      </div>
    )
  }

  if (reason === 'insufficientBalance') {
    return (
      <div className="text-danger p-1" style={{ margin: '0px -15px' }}>
        <h4 className="text-danger p-1">Внимание!</h4>
        <p className="text-danger p-1">
          Недостаточно средств на балансе для создания проверки. Пополните баланс во вкладке <a href={billingPath}>«счета и оплаты»</a>.
        </p>
      </div>
    )
  }

  return (
    <div className="text-danger p-1" style={{ margin: '0px -15px' }}>
      <h4 className="text-danger p-1">Внимание!</h4>
      <p className="text-danger p-1">
        Вы были заблокированы за неуплату. Для разблокировки просьба оплатить счет. Его можно найти во вкладке{' '}
        <a href={billingPath}>«счета и оплаты»</a>. После этого с квитанцией необходимо обратиться в{' '}
        <a href="https://t.me/otk5757" target="_blank" rel="noopener noreferrer">
          поддержку ОТК
        </a>
        !
      </p>
    </div>
  )
}

export default BlockingWarning
